import $ from "jquery";

// safariだけwebfontの縦書きが崩れる問題対応のためUA判別、今後廃止されるかもしれないのでできるだけ使わない方向
window.addEventListener('DOMContentLoaded', () => {
  let elBody = document.querySelector('body');
  var userAgent = window.navigator.userAgent.toLowerCase();
  console.log(userAgent);
  if (userAgent.indexOf('safari') != -1) {
    console.log('ブラウザはSafariです');
    elBody?.classList.add('is_ua_safari');
  }
});

const sleep = waitTime => new Promise( resolve => setTimeout(resolve, waitTime) );

let headerCommittee = false;
let menuCommittee = false;
let hasHeader = false;

$(() => {
  $('#ctl-header').on('mouseenter', () => {
    hasHeader = true;
  });
  $('#ctl-header').on('mouseleave', () => {
    hasHeader = false;
  });
  $('#header-committee-menu').on('mouseenter', () => {
    menuCommittee = true;
  });
  $('#header-committee-menu').on('mouseleave', () => {
    menuCommittee = false;
    sleep(2)
      .then (() => {
        if (!headerCommittee) {
          $("#header-committee-menu").slideUp("");
        }
      });
  });
  $('#header-committee').on('mouseenter', () => {
    headerCommittee = true;
    $("#header-committee-menu").slideDown("");
  });
  $('#header-committee').on('mouseleave', () => {
    headerCommittee = false;
    sleep(2)
      .then (() => {
        if (!menuCommittee && hasHeader) {
          $("#header-committee-menu").slideUp("");
        }
      });
  });
  $('#menu-about-check').on('click', () => {
    $("#menu-about-sub").slideToggle("");
    $('#menu-about-check').toggleClass("is_open");
  });
  $('#menu-committee-check').on('click', () => {
    $("#menu-committee-sub").slideToggle("");
    $('#menu-committee-check').toggleClass("is_open");
  });
  $('#scroll-top').on('click', () => {
    $('html, body').animate({scrollTop:0});
  });

  if (location.pathname.match('/about-event-anniversary')) {
    $('#hokkaido').on('click', () => {
      $("#hokkaido-detail").slideToggle("");
      $('#hokkaido').toggleClass("is_open");
    });
    $('#tohoku').on('click', () => {
      $("#tohoku-detail").slideToggle("");
      $('#tohoku').toggleClass("is_open");
    });
    $('#kanto').on('click', () => {
      $("#kanto-detail").slideToggle("");
      $('#kanto').toggleClass("is_open");
    });
    $('#chubu').on('click', () => {
      $("#chubu-detail").slideToggle("");
      $('#chubu').toggleClass("is_open");
    });
    $('#hokuriku').on('click', () => {
      $("#hokuriku-detail").slideToggle("");
      $('#hokuriku').toggleClass("is_open");
    });
    $('#kansai').on('click', () => {
      $("#kansai-detail").slideToggle("");
      $('#kansai').toggleClass("is_open");
    });
    $('#chugoku').on('click', () => {
      $("#chugoku-detail").slideToggle("");
      $('#chugoku').toggleClass("is_open");
    });
    $('#shikoku').on('click', () => {
      $("#shikoku-detail").slideToggle("");
      $('#shikoku').toggleClass("is_open");
    });
    $('#kyushu').on('click', () => {
      $("#kyushu-detail").slideToggle("");
      $('#kyushu').toggleClass("is_open");
    });
    $('#okinawa').on('click', () => {
      $("#okinawa-detail").slideToggle("");
      $('#okinawa').toggleClass("is_open");
    });
  }

  if (location.pathname.match('/seminar')) {
    $(".students").on('click', (e) => {
      const $target = $(e.target);
      const $parent = $target.parent();
      $parent.toggleClass("is_open");
      $parent.find('.students-content').slideToggle("");
      console.log($target);
      console.log($parent);
    });
  }
});
